var Status;
(function (Status) {
  Status["PROCESSING"] = "processing";
  Status["FAILED"] = "failed";
  Status["SUCCEEDED"] = "succeeded";
  Status["HIDDEN"] = "hidden";
  Status["DONE"] = "done";
  Status["NOT_DONE"] = "notDone";
  Status["PENDING"] = "pending";
})(Status || (Status = {}));

export { Status };
//# sourceMappingURL=status.mjs.map
